import Accounting from './Accounting';

export default Accounting;
